/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Rupesh Raj",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Rupesh Raj Portfolio",
    type: "website",
    url: "http://ashutoshhathidara.com/",
  },
};

//Home Page
const greeting = {
  title: "Rupesh Raj",
  logo_name: "Rupesh Raj",
  nickname: "rupesh_raj17",
  subTitle:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  resumeLink:
    "https://drive.google.com/file/d/1Ljv9skhAs3QWaAV24163ACbNMsjGi_SR/view?usp=sharing",
  portfolio_repository: "https://github.com/rupesh-raj17",
  githubProfile: "https://github.com/rupesh-raj17",
};

const socialMediaLinks = [
 
  {
    name: "Github",
    link: "https://github.com/rupesh-raj17",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/rupesh-raj-b23826190/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:rupeshraj17521.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/rupesh_raj17",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/profile.php?id=100038240800404",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/rupesh_raj17/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "",
      fileName: "",
      skills: [
        
      ],
      softwareSkills: [
        
        
      
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React.",
        "⚡ Creating application backend in using MERN ",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "##E34F26",
          },
        },
        {
          skillName: "Tailwind Css",
          fontAwesomeClassname: "simple-icons:tailwindcss",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#47A248",
          },
        },
        
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "Netlify",
          fontAwesomeClassname: "simple-icons:netlify",
          style: {
            color: "#FFCA28",
          },
        },
        
        {
          skillName: "Visual Studio Code",
          fontAwesomeClassname: "simple-icons:visualstudiocode",
          style: {
            color: "#1488C6",
          },
        },
        
      ],
    },
    {
      title: "Blockchain Developement",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on Ethereum Blockchain Token",
        "⚡Building responsive Decentralized Apps using Smart Contracts , Solidity and react.",
        
      ],
      softwareSkills: [
        {
          skillName: "Ethereum",
          fontAwesomeClassname: "simple-icons:ethereum",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "soldity",
          fontAwesomeClassname: "simple-icons:solidity",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Metamask",
          fontAwesomeClassname: "logos:metamask-icon",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Remix",
          fontAwesomeClassname: "simple-icons:remix",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "Ganache",
          fontAwesomeClassname: "logos:ganache",
          style: {
            color: "#336791",
          },
        },
        
        {
          skillName: "Hardhat",
          fontAwesomeClassname: "logos:hardhat-icon",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Smart Contracts",
          fontAwesomeClassname: "clarity:contract-line",
          style: {
            color: "#326CE5",
          },
        },
        {
          skillName: "Truffle",
          fontAwesomeClassname: "logos:truffle",
          style: {
            color: "FF9900",
          },
        },
      ],
    },
    {
      title: "",
      fileName: "",
      skills: [
       
      ],
      softwareSkills: [
        
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "GeeksforGeeks",
      iconifyClassname: "simple-icons:geeksforgeeks",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://auth.geeksforgeeks.org/user/rupeshraj17",
    },
    {
      siteName: "Leetcode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://leetcode.com/rupesh_raj17/",
    },
    /*{
      siteName: "InterviewBit",
      iconifyClassname: "simple-icons:",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "https://www.interviewbit.com/profile/rupesh-raj_823",
    },*/
    {
      siteName: "CodePen",
      iconifyClassname: "fe:codepen",
      style: {
        color: "#323754",
      },
      profileLink: "https://codepen.io/rupesh-raj17",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.hackerrank.com/rupesh_raj17",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "National Institute of Technology Patna",
      subtitle: "B.Tech. in Electronics and Communication Engineering",
      logo_path: "nitp-modified.png",
      alt_name: "NIT Patna",
      duration: "2019 - Present",
      descriptions: [
        "⚡ I have studied basic software and electronics engineering subjects like DS, Algorithms, DBMS, OS, CN, VLSI, Embeded Systems, Wireless Comm, Analog and Digital Comm, MPMC etc.",
        "⚡ Apart from this, I have done courses on Blockchain, Machine Learning, Joy of Computing using Python, Cloud Computing and Full Stack Development.",
        
      ],
      website_link: "http://nitp.ac.in",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "TEDxNITPatna",
      subtitle: "- NIT Patna",
      logo_path: "tedxnitp.png",
      certificate_link:
        "https://drive.google.com/file/d/1M2O3e10F6RtzxDUfwN2ZoDjCHHppIkyB/view?usp=sharing",
      alt_name: "NIT Patna",
      color_code: "#8C151599",
    },
    {
      title: "ReSkill Spark AR",
      subtitle: "- Meta",
      logo_path: "sparkAR.png",
      certificate_link:
        "https://drive.google.com/file/d/1vi4U9QPc-xauYtGDt59tWRrKVwXRuXf8/view?usp=sharing",
      alt_name: "spark AR",
      color_code: "#1F70C199",
    },
    {
      title: "Webvyom",
      subtitle: "- IEEE NITP",
      logo_path: "ieeenitp.png",
      certificate_link:
        "https://drive.google.com/file/d/1jywQ9t99MuG6koMRdcY1OoSj2nsfo9wc/view?usp=sharing",
      alt_name: "IEEE NITP",
      color_code: "#0C9D5899",
    },
    {
      title: "E-Robo",
      subtitle: "- IEEE NITP",
      logo_path: "ieeenitp.png",
      certificate_link:
        "https://drive.google.com/file/d/1HesWGAJZNE6GCLBkA2H3xTy9zx3_pHsh/view?usp=sharing",
      alt_name: "IEEE NITP",
      color_code: "#1F70C199",
    },
    {
      title: "Gravitas'20",
      subtitle: "-Vit Vellore",
      logo_path: "vit.png",
      certificate_link:
        "https://drive.google.com/file/d/14WtusdjtSNDBGigUydkn3NtY2KbMhbn4/view?usp=sharing",
      alt_name: "Vit Vellore",
      color_code: "#D83B0199",
    },
    {
      title: "Optical Fiber Communication System",
      subtitle: "- Indian Railways",
      logo_path: "ind_rail.png",
      certificate_link:
        "https://drive.google.com/file/d/1YR1IoJFkciFreIl61rmZO9YOI_m9bNvM/view?usp=sharing",
      alt_name: "Indian Railways",
      color_code: "#1F70C199",
    },
    {
      title: "AITA",
      subtitle: "- NIT PATNA",
      logo_path: "nitp-modified.png",
      certificate_link:
        "https://drive.google.com/file/d/1JMPrt3x_oT9RkTIUgRDhb39foOxDpI_o/view?usp=sharing",
      alt_name: "NIT PATNA",
      color_code: "#0C9D5899",
    },
      {
      title: "Cloud Computing",
      subtitle: "- IEEE NITP",
      logo_path: "ieeenitp.png",
      certificate_link:
        "https://drive.google.com/file/d/1yNKuLL57I1idhIWwxqoWMC88VXqTfuMD/view?usp=sharing",
      alt_name: "IEEE NITP",
      color_code: "#00000099",
    },
    {
      title: "SMDC",
      subtitle: "- Robotics Club NITP",
      logo_path: "robo.png",
      certificate_link:
        "https://drive.google.com/file/d/1yNKuLL57I1idhIWwxqoWMC88VXqTfuMD/view?usp=sharing",
      alt_name: "Robotics Club NITP",
      color_code: "#2A73CC",
    },
    {
      title: "IIT Bombay Mapathon",
      subtitle: "- IIT Bombay",
      logo_path: "Indian_Institute_of_Technology_Bombay_Logo.svg.png",
      certificate_link:
        "https://drive.google.com/file/d/18JWZDLuFlYASTUkyiGeQ5byJLja4D1LG/view?usp=sharing",
      alt_name: "IITB",
      color_code: "#4285F499",
    },
    {
      title: "Joy of Computing using Python",
      subtitle: "- Sudarshan Iyengar",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1sRUvYurSOsaF3YqHMLWPqfTbQ_2Btn2w/view?usp=sharing",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "An introduction to Programming through C++",
      subtitle: "- Dr. Abhiram Ranade",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1418sB_jdSqi12DM_tjTHytC70WLxMvGZ/view?usp=sharing",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have worked with many societies in my college and also outside the campus. Along With  this i have also done internship in Indian Railways in Signalling and Telecommunication Department.I have also worked with some well established companies mostly as AI Developer. I love organising events and that is why I am also involved with many communities as a representative.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "East Central Railway Intern",
          company: "Indian Railways.",
          company_url: "https://www.indianrail.gov.in/",
          logo_path: "ind_rail.png",
          duration: "June 2022 - July 2022",
          location: "Patna, Bihar",
          description:
            "I have worked on Railnet Networking, VoIP based Exchange, Optical Fibre Communication System, Quad Cable Communication system, PRS/UTS working system, Mobile Train Radio Communication, Signal Interlocking system, Basic Signaling system etc.",
          color: "#ee3c26",
        },
        
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "IEEE SB NITP Chairperson",
          company: "IEEE NITP SB",
          company_url: "https://ieee.nitp.ac.in/",
          logo_path: "ieeenitp.png",
          duration: "June 2022 - Present",
          location: "Patna, Bihar",
          description:
            "Handling a Team of more than 80 people an Conducting various event inside and across the country under the club.",
          color: "#4285F4",
        },

        {
          title: "IEEE SB NITP Media Head",
          company: "IEEE NITP SB",
          company_url: "https://ieee.nitp.ac.in/",
          logo_path: "ieeenitp.png",
          duration: "Jan 2020 - June 2022",
          location: "Patna, Bihar",
          description:
            "Conducted various events like E-Robo, Impulse , Queso-e-Quest etc and managed the social Media Handles of the club.",
          color: "#D83B01",
        },
       
        {
          title: "Robotics Club NITP PR Memeber",
          company: "Robotics Club NITP",
          company_url: "https://roboticsnitp.co.in/",
          logo_path: "robo.png",
          duration: "Jan 2020 - May 2021",
          location: "Patna, Bihar",
          description:
            "Conducted Various events like abhiyuthhan,organised live sessions and Managed the Social media handles",
          color: "#000000",
        },
        {
          title: "Hackslash NITP Member",
          company: "Hackslash NIT Patna",
          company_url:
            "https://hackslash.co.in/",
          logo_path: "hs.png",
          duration: "Jan 2020 - May 2021",
          location: "Patna, Bihar",
          description:
            "Contributed in Open-source Projects",
          color: "#0C9D58",
        },
        {
          title: "Campus Ambassador",
          company: "VIT Vellore",
          company_url: "https://vit.ac.in/",
          logo_path: "vit.png",
          duration: "Sept 2020",
          location: "Work From Home",
          description:
            "Campus Ambassador of the event Gravitas'20",
          color: "#181717",
        },
        {
          title: "Media Head",
          company: "TedxNITPatna",
          company_url: "https://tedxnitpdemo.netlify.app/",
          logo_path: "tedxnitp.png",
          duration: "Dec 2020 - Mar 2021",
          location: "Patna, Bihar",
          description:
            "Managed the social Media Handle of the society",
          color: "#4285F4",
        },
        {
          title: "Member",
          company: "National Service Scheme NITP",
          company_url: "https://beta.nitp.ac.in/students/?tab=nss",
          logo_path: "nss.jpeg",
          duration: "Dec 2019 - Mar 2021",
          location: "Patna, Bihar",
          description:
            "",
          color: "#0C9D58",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Blockchain projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzt=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzb=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "cropped_Rupesh.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours.",
  },
  blogSection: {
    
  },
  
  addressSection: {
    title: "Address",
    subtitle:
      "New Dashratha, Aadarsh Nagar, Dist.-Patna, Bihar - 800002",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/WEyjZa1absMQLGCa8",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 9534222628",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
